import React from "react";
import StaticContentPage from "../components/StaticContentPage";

export default function About() {
  return (
    <StaticContentPage
      title="About CryptoBag | CryptoBag"
      description="Learn what CryptoBag covers, how the site is evolving, and why it aims to combine market intelligence with educational crypto content."
      canonical="https://cryptobag.net/about"
      eyebrow="About"
      heading="A clearer way to follow and understand crypto."
      intro="CryptoBag is built to be more than a crypto price dashboard. It combines market data, sentiment, coin insights, news, and original content to help people follow the market and better understand the broader crypto ecosystem."
      sections={[
        {
          title: "What CryptoBag Covers",
          paragraphs: [
            "CryptoBag is designed to cover both the market side of crypto and the understanding side of crypto. That includes live prices, asset rankings, coin insights, sentiment, news, and original content that helps explain how the space works and why certain trends matter.",
            "Over time, that coverage will continue to expand through more original articles, explainers, and broader educational content about crypto itself.",
          ],
        },
        {
          title: "What CryptoBag Is Not",
          paragraphs: [
            "CryptoBag is an informational platform, not a trading platform. It does not process transactions, hold assets, manage portfolios, or provide personal investment recommendations.",
            "Visitors should use the site as a research and market-awareness tool, not as a substitute for financial, legal, or tax advice.",
          ],
        },
      ]}
    />
  );
}
